import { signOut } from 'aws-amplify/auth';
import { tokenManager } from './tokenManager';

let idleTimer: NodeJS.Timeout | null = null;
const IDLE_TIMEOUT = 5 * 60 * 1000; // 5 minutes in milliseconds

let onIdleCallback: (() => void) | null = null;

const resetIdleTimer = () => {
  if (idleTimer) clearTimeout(idleTimer);
  if (onIdleCallback) {
    idleTimer = setTimeout(onIdleCallback, IDLE_TIMEOUT);
  }
};

const handleActivity = () => {
  resetIdleTimer();
};

export const startIdleTimer = (onIdle: () => void) => {
  onIdleCallback = onIdle;
  resetIdleTimer();
  window.addEventListener('mousemove', handleActivity);
  window.addEventListener('keypress', handleActivity);
};

export const stopIdleTimer = () => {
  if (idleTimer) clearTimeout(idleTimer);
  window.removeEventListener('mousemove', handleActivity);
  window.removeEventListener('keypress', handleActivity);
  onIdleCallback = null;
};

export const handleIdle = async (navigate: (path: string) => void) => {
  //console.log('User is idle. Logging out...');
  await signOut();
  tokenManager.clearTokens();
  navigate('/');
};
